import { IconChevronRight } from "@tabler/icons-react";
import type { SimpleTableColumn } from "../../../../components/common/simple-table";
import { Text } from "../../../../components/common/typography";
import { Chip } from "../../../../components/common/chip";
import { toReadableDate } from "../../../../utils/date";
import type { AdminUserListItem } from "../../hooks/useAdminUsers";

export function buildAdminUsersColumns(): SimpleTableColumn<AdminUserListItem>[] {
  return [
    {
      key: "name",
      label: "Name",
      className: "flex-[2] min-w-0",
      render: (row) => (
        <div className="flex flex-col gap-0.5">
          <Text variant="bodyBold" tone="dark">{row.name}</Text>
          {row.email && <Text variant="bodySm" tone="muted">{row.email}</Text>}
        </div>
      ),
    },
    {
      key: "phone",
      label: "Phone",
      className: "flex-1 min-w-0",
      render: (row) => (
        <Text variant="body" tone="body">{row.phoneNumber || "—"}</Text>
      ),
    },
    {
      key: "role",
      label: "Role",
      className: "flex-shrink-0 w-24",
      render: (row) => (
        row.role === "admin"
          ? <Chip variant="underReview">Admin</Chip>
          : <Chip variant="tertiary">User</Chip>
      ),
    },
    {
      key: "status",
      label: "Status",
      className: "flex-shrink-0 w-24",
      render: (row) => (
        row.isActive
          ? <Chip variant="approved">Active</Chip>
          : <Chip variant="rejected">Inactive</Chip>
      ),
    },
    {
      key: "createdAt",
      label: "Created",
      className: "flex-1",
      render: (row) => (
        <Text variant="body" tone="body">{toReadableDate(row.createdAt)}</Text>
      ),
    },
    {
      key: "action",
      label: "",
      className: "flex-shrink-0 w-10 flex justify-end",
      render: () => (
        <IconChevronRight size={18} className="text-textMuted" />
      ),
    },
  ];
}
